import { Box, CircularProgress } from '@mui/material';
import { CSSProperties } from 'react';

const Loader = ({sx} : {sx? : CSSProperties}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        height: '100%',
        ...sx
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
